export default "__VITE_ASSET__kkeKJ9Xj__"